import dayjs from 'dayjs'

import type { TaskValue } from '#/shared/ui/task-editor'

interface TaskApiInput {
  title: string
  type: TaskValue['type']
  priority: TaskValue['priority']
  date?: string | null
  startTime?: string | null
  assigneeIds?: string[]
}

export function toTaskApiInput(value: TaskValue): TaskApiInput {
  return {
    title: value.task.trim(),
    type: value.type,
    priority: value.priority,
    date: value.date ? dayjs(value.date).format('YYYY-MM-DD') : undefined,
    startTime: value.time ? value.time : undefined,
    assigneeIds: value.users.length > 0 ? value.users : undefined,
  }
}
